module.exports = __webpack_public_path__ + "static/img/main-top-img.bf963b4.png";